import { z } from "zod";

export const schemaPlanoDeContas = z.object({
  plCtRecStatus: z.any(),
  plCtDescricao: z.string().nonempty("Descrição inválida."),
});

export type PlanoDeContasFormProps = z.infer<typeof schemaPlanoDeContas>;
